import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  LayoutDashboard, CreditCard, Users, ShieldCheck,
  FolderOpen, CalendarDays, BarChart3, Building2, Euro, Package
} from 'lucide-react';

const navItems = [
  { path: '/app', icon: LayoutDashboard, label: 'Home' },
  { path: '/app/cantieri', icon: Building2, label: 'Cantieri' },
  { path: '/app/badge', icon: CreditCard, label: 'Badge' },
  { path: '/app/presenze', icon: Users, label: 'Presenze' },
  { path: '/app/sicurezza', icon: ShieldCheck, label: 'Sicurezza' },
  { path: '/app/documenti', icon: FolderOpen, label: 'Documenti' },
  { path: '/app/pianificazione', icon: CalendarDays, label: 'Lavori' },
  { path: '/app/magazzino', icon: Package, label: 'Magazzino' },
  { path: '/app/paga', icon: Euro, label: 'Paga' },
  { path: '/app/reportistica', icon: BarChart3, label: 'Report' },
];

const MobileNav = () => {
  const location = useLocation();

  return (
    <nav className="mobile-nav">
      <div className="mobile-nav-scroll">
        {navItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path ||
            (item.path !== '/' && location.pathname.startsWith(item.path));
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`mobile-nav-item ${isActive ? 'mobile-nav-active' : ''}`}
            >
              <Icon size={18} strokeWidth={isActive ? 2.2 : 1.6} />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileNav;
